import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { NgxMatFileInputModule } from '@angular-material-components/file-input';

const MATERIAL_COMPONENTS = [
  MatCardModule,
  MatButtonModule,
  MatToolbarModule,
  MatMenuModule,
  MatDividerModule,
  MatSidenavModule,
  MatIconModule,
  MatNativeDateModule,
  MatSnackBarModule,
  MatTableModule,
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
  MatRadioModule,
  MatAutocompleteModule,
  MatCheckboxModule,
  MatChipsModule,
  NgxMatFileInputModule
];

@NgModule({
  imports: [],
  exports: [MATERIAL_COMPONENTS],
  providers: []
})
export class MaterialModule {}
